import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/world_map.svg")